import * as types from './action-types';

const defaultState = {
    hasError: false,
    error: null,
    code: '',
    registering: false,
};

const reducer = (state = defaultState, action) => {
    switch (action.type) {
    case types.REGISTER_PENDING:
        return Object.assign({}, state, {
            hasError: false,
            error: null,
            code: '',
            registering: true,
        });
    case types.REGISTER_FAILURE:
        return Object.assign({}, state, {
            hasError: true,
            error: action.error,
            code: action.error.code,
            registering: false,
        });
    case types.REGISTER_SUCCESS:
        return Object.assign({}, state, {
            hasError: false,
            error: null,
            code: action.res.code,
            registering: false,
        });
    default:
        return Object.assign({}, state);
    }
};

export default reducer;
